import {Injectable} from '@angular/core';
import {environment} from '../../../environments/environment.local';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ProfilsEntitesUtilisateurBody} from '../../models/profilsEntitesUtilisateur/ProfilsEntitesUtilisateurBody';
import {
  ProfilsEntitesUtilisateurResponse,
  ProfilsEntitesUtilisateursResponse
} from '../../models/profilsEntitesUtilisateur/ProfilsEntitesUtilisateurResponse';
import {
  ProfilsEntitesUtilisateurDeleteResponse
} from '../../models/profilsEntitesUtilisateur/ProfilsEntitesUtilisateurDeleteResponse';
import {Params} from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ProfilsEntitesUtilisateursService {

  private apiUrl = `${environment.apiUrl}/profils-entities-users`;

  constructor(private http: HttpClient) {
  }

  getProfilEntityUserById(id: string): Observable<ProfilsEntitesUtilisateurResponse> {
    return this.http.get<ProfilsEntitesUtilisateurResponse>(`${this.apiUrl}/${id}`);
  }

  getProfilEntityUser(params?: Params): Observable<ProfilsEntitesUtilisateursResponse> {
    return this.http.get<ProfilsEntitesUtilisateursResponse>(this.apiUrl, {params});
  }

  postProfilEntityUser(profilsEntitesUtilisateurBody: ProfilsEntitesUtilisateurBody[]): Observable<ProfilsEntitesUtilisateurResponse> {
    return this.http.post<ProfilsEntitesUtilisateurResponse>(this.apiUrl, profilsEntitesUtilisateurBody);
  }

  updateProfilEntityUser(id: string, profilsEntitesUtilisateurBody: ProfilsEntitesUtilisateurBody): Observable<ProfilsEntitesUtilisateurResponse> {
    return this.http.put<ProfilsEntitesUtilisateurResponse>(`${this.apiUrl}/${id}`, profilsEntitesUtilisateurBody);
  }

  deleteProfilEntityUser(id: number): Observable<ProfilsEntitesUtilisateurDeleteResponse> {
    return this.http.delete<ProfilsEntitesUtilisateurDeleteResponse>(`${this.apiUrl}/${id}`);
  }
}
